import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformOrganizationItem } from '../../shared/services/api.service';

@Component({
  selector: 'app-platform-organizations-table',
  templateUrl: './platform-organizations-table.component.html',
  styleUrls: ['./platform-organizations-table.component.css'],
})
export class PlatformOrganizationsTableComponent {
  @Input() organizations: PlatformOrganizationItem[] = [];
  @Output() edit = new EventEmitter<PlatformOrganizationItem>();
  @Output() delete = new EventEmitter<PlatformOrganizationItem>();
  @Output() billing = new EventEmitter<PlatformOrganizationItem>();
  displayedColumns: string[] = [
    'logo',
    'displayName',
    'status',
    'orgId',
    'memberCount',
    'totalSpend',
    'monthSpend',
    'actions',
  ];

  private readonly zarFormatter = new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  formatZarFromCents(value: number | null | undefined): string {
    const cents = Number(value || 0);
    return this.zarFormatter.format(cents / 100);
  }

  handleLogoError(event: Event): void {
    const img = event.target as HTMLImageElement | null;
    if (img) {
      img.style.display = 'none';
    }
  }

  editOrganization(org: PlatformOrganizationItem): void {
    this.edit.emit(org);
  }

  deleteOrganization(org: PlatformOrganizationItem): void {
    this.delete.emit(org);
  }

  openBilling(org: PlatformOrganizationItem): void {
    this.billing.emit(org);
  }

  monthSpendTooltip(org: PlatformOrganizationItem): string {
    return org.billingPaymentType === 'INVOICE'
      ? 'Month Spend is billed accrual for invoice organizations.'
      : 'Month Spend is collected successful charges for card organizations.';
  }
}
